module.exports = __webpack_public_path__ + "img/undo.2b60d930.svg";